<app-cms-footer
  class="organizer-cms-footer"
  [title]="title"
  [description]="description"
  [columns]="columns"
  [logo]="logo"
></app-cms-footer>
